import { get } from 'lodash';

import { FIELD_PATHS, FIELD_VALUES } from '@funnels/constants';
import { FormValues, StoreApplicant } from '@funnels/types';

export const isLastApplicantByType = (
  values: FormValues,
  applicantIndex: number,
  applicantType: string = FIELD_VALUES.BORROWER
) => {
  const applicants = get(values, FIELD_PATHS.APPLICANTS(), []);
  const filteredApplicants = applicants.filter(
    (applicant: StoreApplicant) => get({ applicants: [applicant] }, FIELD_PATHS.APPLICANT_TYPE(0)) === applicantType
  );

  const filteredIndex = filteredApplicants.findIndex(
    (filteredApplicant: StoreApplicant) =>
      get({ applicants: [filteredApplicant] }, FIELD_PATHS.APPLICANT_CLIENT_ID(0)) ===
      get(values, FIELD_PATHS.APPLICANT_CLIENT_ID(applicantIndex))
  );

  return filteredApplicants.length === filteredIndex + 1;
};
